// extracted by mini-css-extract-plugin
export var linkText = "_ri-0";